import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import Helmet from 'react-helmet';
import ShoppingCartStore from '../../stores/ShoppingCartStore';
import ShoppingCartContents from '../../components/ShoppingCartContents';
import styles from '../BaseContainer/index.sass';

class ShoppingCartContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this._cartViewedEventTracked = false;
  }

  componentDidMount() {
    this.trackCartViewedEvent();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    this.trackCartViewedEvent();
  }

  trackCartViewedEvent() {
    // Only call once per 'mount'
    if(this._cartViewedEventTracked || !this.props.shoppingCart) {return;}
    this.context.trackEvent('Cart Viewed', {
      cart_id: this.props.shoppingCart.id,
      products: this.props.shoppingCart.items.map((item) => {
        return {product_id: item.inventory_record.id};
      }).toJS()
    });
    this._cartViewedEventTracked = true;
  }

  getHelmetProps(store) {
    let title = `Your Bag – ${store.name}`;
    return {
      title: title,
      meta: []
    };
  }

  render() {
    let { store, shoppingCart, shoppingCartError, shoppingCartRequestStatus, customer } = this.props;
    let shoppingCartContentsProps = { store, shoppingCart, shoppingCartError, shoppingCartRequestStatus, customer };

    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(this.props.store)} />
        <ShoppingCartContents {...shoppingCartContentsProps} />
      </section>
    );
  }
}

ShoppingCartContainer = connectToStores(ShoppingCartContainer, [ShoppingCartStore], (context, props) => {
  let storeId = props.store.id;
  let shoppingCartStore = context.getStore(ShoppingCartStore);
  let shoppingCart = shoppingCartStore.getShoppingCartByStoreId(storeId);
  return {
    shoppingCart,
    shoppingCartError: shoppingCartStore.getErrorByStoreId(storeId),
    shoppingCartRequestStatus: shoppingCartStore.getRequestStatusByStoreId(storeId)
  };
});

export default ShoppingCartContainer;



// WEBPACK FOOTER //
// banquet/containers/ShoppingCartContainer/index.js